import React from 'react';
import Styled from 'styled-components';

const Logo = Styled.div`
  display: flex;
  max-width: 128px;
  max-height: 128px;

  & > * {
    width: 100%;
    height: auto;
    object-fit: contain;
  }
`;

const StyledNekoLogo = () => {
  return (
    <Logo className='neko-logo'>
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 1434 947">
        <path fill="#000" d="M805 777a792 792 0 0 1-262-43 811 811 0 0 1-286-164A959 959 0 0 1 6 200 158 158 0 0 1 304 97c41 96 94 175 159 233a497 497 0 0 0 376 129 60 60 0 0 1 67 60l27 186c4 33-18 63-51 68-6 0-34 4-77 4ZM122 168l2 5a841 841 0 0 0 212 307 692 692 0 0 0 469 177l-11-76a616 616 0 0 1-412-162 769 769 0 0 1-188-276 38 38 0 0 0-50-20c-18 7-27 27-22 45Z"/>
        <path fill="#FDA960" d="m64 184 4 12a900 900 0 0 0 228 329 752 752 0 0 0 577 188l-27-194a563 563 0 0 1-423-144 709 709 0 0 1-174-255 98 98 0 0 0-185 64Z"/>
        <mask id="a" width="814" height="657" x="60" y="60" maskUnits="userSpaceOnUse">
          <path fill="#fff" d="m64 184 4 12a900 900 0 0 0 228 329 752 752 0 0 0 577 188l-27-194a563 563 0 0 1-423-144 709 709 0 0 1-174-255 98 98 0 0 0-185 64Z"/>
        </mask>
        <g mask="url(#a)">
          <path fill="#804625" d="M120 532c-41 0-84-5-130-15l31-145c101 21 180 12 233-27 70-51 80-141 80-142l149 13a363 363 0 0 1-139 248 351 351 0 0 1-224 68Zm369 175c47-31 84-71 110-116 32-56 46-123 42-192-3-51-15-87-16-91l-141 48a225 225 0 0 1-15 161c-33 58-101 99-203 120l30 146c76-16 141-41 193-76ZM62 269c64-4 122-22 174-53A413 413 0 0 0 421-47L184-92v-1s-16 71-73 103C92 21 70 27 44 29 7 31-37 24-86 8l-74 229a623 623 0 0 0 222 32Z"/>
        </g>
        <path fill="#000" d="M1373 947h-110c-33 0-60-27-60-60v-97l-36 87a62 62 0 0 1-56 37h-79c-25 0-46-14-56-37l-36-87v97c0 33-27 60-60 60H769c-33 0-60-27-60-60V316c0-33 27-60 60-60h141c24 0 46 15 55 37l106 258 107-258c9-22 31-37 55-37h140c34 0 60 27 60 60v571c0 33-26 60-60 60Zm-316-188 14 34 15-34-11 1h-7l-11-1Zm199-314h7c21 0 40 11 50 28v-97h-40l-29 70 12-1Zm-427-69v97c11-17 29-28 51-28h6l13 1-29-70h-41Z"/>
        <path fill="#fff" d="M769 887V316h141l158 384h7l158-384h140v571h-110V505h-7l-145 349h-79L886 505h-6v382H769Z"/>
      </svg>
    </Logo>
  );
}

const NekoLogo = (props) => {
  return (<StyledNekoLogo {...props} />);
}

NekoLogo.propTypes = {
};

export { NekoLogo };
